export default "__VITE_ASSET__C$d1lliV__"